import classNames from "classnames";
import { BinIcon } from "../icon/Icon";
import React from "react";
import { PresetButtonStyled } from "./styled/PresetButtonStyled";

function PresetButton(props) {
    const {big, disabled, icon, title, value, onClick} = props;
    return <PresetButtonStyled data-value={value} onClick={onClick} className={classNames('preset-button', {
        big: !!big,
        disabled: !!disabled,
    })}>
        {icon ? <BinIcon name={icon}/> : title}
    </PresetButtonStyled>
}

export default PresetButton;
